module.exports = "/_next/static/images/309c90772896ed2c9a7f8095ed4283f7-hero-desktop-v1.jpg";